import { linkInfo } from './constants';
import { PodcatcherLinkProps } from './types';

export const getLinkPropsFromSource = (source: PodcatcherLinkProps['source']) =>
  linkInfo[source];
